import { Button } from '@/components/ui/button'
import { TourContent } from '../components/tour-content/tour-content-compound'
import { useTourStore } from '../stores/useTourStore'
import type { TourConfig } from '../types'

const WelcomeContent = () => {
  const { completeTour, nextStep } = useTourStore()

  const handleSkip = () => {
    completeTour()
  }

  const handleGetStarted = () => {
    nextStep()
  }

  return (
    <TourContent
      // @ts-ignore - TypeScript cache issue with intent prop
      intent='welcome'
    >
      <TourContent.Header>
        <TourContent.Title>Welcome to RTSC!</TourContent.Title>
      </TourContent.Header>
      <TourContent.Body>
        <TourContent.Description>
          Streamline how your PR team connects with the sports media and fans.
        </TourContent.Description>
      </TourContent.Body>
      <TourContent.Footer>
        <TourContent.Actions alignment='between'>
          <Button
            // @ts-ignore - TypeScript cache issue with variant prop
            variant='outline'
            onClick={handleSkip}
          >
            Skip
          </Button>
          <Button onClick={handleGetStarted}>Get Started</Button>
        </TourContent.Actions>
      </TourContent.Footer>
    </TourContent>
  )
}

const CompanyCreationContent = () => {
  const { completeTour, nextStep } = useTourStore()

  const handleSkip = () => {
    completeTour()
  }

  const handleCreateCompany = () => {
    // Just complete the tour and close the modal
    completeTour()
  }

  return (
    <TourContent
      // @ts-ignore - TypeScript cache issue with intent prop
      intent='info'
    >
      <TourContent.Header>
        <TourContent.Title>Create Your Company</TourContent.Title>
      </TourContent.Header>
      <TourContent.Body>
        <TourContent.Description>
          To get started, please create your company here. This will set up your team's workspace and allow you to start
          collaborating with your PR team.
        </TourContent.Description>
      </TourContent.Body>
      <TourContent.Footer>
        <TourContent.Actions alignment='between'>
          <Button
            // @ts-ignore - TypeScript cache issue with variant prop
            variant='outline'
            onClick={handleSkip}
          >
            Skip
          </Button>
          <Button onClick={handleCreateCompany}>I'm ready</Button>
        </TourContent.Actions>
      </TourContent.Footer>
    </TourContent>
  )
}

export const welcomeTour: TourConfig = {
  id: 'welcome',
  name: 'Welcome Tour',
  nextTour: 'dashboard',
  initialRoute: '/companies',
  steps: [
    {
      target: 'body',
      content: <WelcomeContent />,
      placement: 'center',
      hideCloseButton: true,
      hideBackButton: true,
      showSkipButton: false,
      hideFooter: true,
      spotlightClicks: true,
      styles: {
        spotlight: {
          display: 'none',
        },
      },
      disableBeacon: true,
    },
    {
      target: '#create-company-button',
      content: <CompanyCreationContent />,
      placement: 'top',
      hideCloseButton: true,
      hideBackButton: true,
      showSkipButton: false,
      hideFooter: true,
      spotlightClicks: true,
      disableBeacon: true,
      styles: {
        spotlight: {
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          borderRadius: '8px',
        },
      },
    },
  ],
}
